import { cn } from "@dalmatech/ui"

export const triggerButton = cn(
  "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200 transition-colors"
)
export const dialogContent = cn(
  "fixed z-50 flex flex-col bg-white focus:outline-none",
  // Mobile: full-screen; Desktop: centered via m-auto (avoids transform conflict with animations)
  "inset-0",
  "md:m-auto md:h-fit md:w-[432px] md:max-w-[432px] md:rounded-2xl md:shadow-lg md:border md:border-neutral-200",
  // Animations
  "data-[state=open]:animate-in data-[state=closed]:animate-out",
  "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
  "data-[state=open]:slide-in-from-bottom-4 data-[state=closed]:slide-out-to-bottom-4"
)
export const header = cn(
  "flex shrink-0 items-center border-b border-neutral-200 p-4",
  "md:justify-end md:border-none md:px-6 md:pt-6 md:pb-0"
)
export const closeButton = cn(
  "flex h-10 w-10 items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200 transition-colors"
)
export const body = cn("flex flex-1 flex-col items-center gap-6 overflow-auto px-4 py-6 md:px-6 ")
export const titleWrapper = cn("flex w-full flex-col gap-2 text-center")
export const title = cn(
  "font-buenosAires text-xl font-bold leading-6 tracking-tight text-neutral-900"
)
export const description = cn("text-sm leading-5 text-neutral-600")
export const form = cn("flex w-full flex-col gap-4")
export const errorBanner = cn(
  "flex w-full items-start gap-2 rounded-xl bg-red-50 px-4 py-3 text-sm leading-5 text-red-700"
)
